import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Button, toast, setOptions, alert} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import './styles/header.css';
import HeaderAccount from "./dialogs/HeaderAccount";
import HeaderRegister from "./dialogs/HeaderRegister";
import Empty from "./utils/Empty";
import Spanish from "./locale/spanish.json";
import English from "./locale/english.json";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLanguage} from "@fortawesome/pro-duotone-svg-icons";
import DashboardWorkspaceApp from "./blocks/DashboardWorkspaceApp";
import {NetworkContext} from "./utils/NetworkContext";
import DashboardWorkspaceImage from "./blocks/DashboardWorkspaceImage";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function Header({locale, dialog, Dialog, configuration, setLocale, setConfiguration, account, wss, setDialog, setNavigation, width, registration, setRegistration, app, setApp}) {
    const {restCall, restResponse, setRestResponse} = useContext(NetworkContext);
    const [iconHover, setIconHover] = useState(null);
    const [workspaceItem, setWorkspaceItem] = useState({});

    const App = data => {

        const message = {
            type: 'rest',
            path: 'app',
            action: 'get',
            data: {
                app: data
            }
        };
        restCall(message);
    }

    const Configuration = data => {
        const message = {
            type: 'rest',
            path: 'account-configuration',
            action: 'get',
            data: {
                account: data
            }
        };
        restCall(message);
    }

    const ButtonLocale = () => {
        if (window.localStorage.locale === 'en') {
            window.localStorage.locale = 'es';
            setLocale(Spanish);
        } else if (window.localStorage.locale === 'es') {
            window.localStorage.locale = 'en';
            setLocale(English);
        }
    }

    const GetAccountConfiguration = useCallback(data => {
        if (data.configuration) {
            let item = {...data.configuration};
            item.locale.es = Object.assign(item.locale.es, Spanish);
            item.locale.en = Object.assign(item.locale.en, English);
            setConfiguration(item);
            if (window.localStorage.locale && window.localStorage.locale === 'en') {
                setLocale(item.locale.en);
            } else if (window.localStorage.locale && window.localStorage.locale === 'es') {
                setLocale(item.locale.es);
            }
        }
        if (data.account) {
            account.current = data.account;
            window.localStorage.account = data.account;
        }
        if (data.url) {
            wss.current = data.url;
        }
        if (data.dialog) {
            setDialog(data.dialog);
        }
        if (data.navigation) {
            setNavigation(data.navigation);
        }
        if (data.expired) {
            window.localStorage.removeItem('token');
        }
        if (data.error) {
            toast({message: locale.header.a, color: 'danger', display: 'bottom', duration: 3000});
        }
    }, [locale.header.a]);

    const GetApp = useCallback(data => {
        if (data.app) {
            setWorkspaceItem(data.app);
        }
        if (data.error) {
            alert({
                title: "Error",
                message: data.text,
                display: 'center'
            })
        }
    }, []);

    useEffect(() => {
        if (!wss.current && restResponse && !Empty(restResponse) && restResponse.action === 'get' && restResponse.path === 'app') {
            GetApp(restResponse.data);
            setRestResponse({});
        }
    }, [restResponse, GetApp, setRestResponse]);

    useEffect(() => {
        if (!wss.current && restResponse && !Empty(restResponse) && restResponse.action === 'get' && restResponse.path === 'account-configuration') {
            GetAccountConfiguration(restResponse.data);
            setRestResponse({});
        }
    }, [restResponse, GetAccountConfiguration, setRestResponse]);

    useEffect(() => {
        if (app) {
            App(app);
        } else if (!account.current) {
            Dialog({view: 'headerAccount'});
        } else if (registration) {
            Dialog({view: 'headerRegister'});
        } else if (account.current && !wss.current) {
            Configuration(account.current);
        }
    }, []);

    return (
        <div className="mbsc-grid cs-header-toolbar">
            <div className="mbsc-row">
                <div className="mbsc-col" >
                    <div className="mbsc-row cs-header-col-start">
                        <div style={configuration.logo ? {backgroundImage: `url(${configuration.logo})`} : {backgroundImage: `url(${configuration.logoCS})`}} className="cs-header-logo" />
                        <Button onClick={() => Dialog({view: 'headerAccount'})} color="primary" className="cs-header-button mbsc-bold" variant="flat" >
                            {configuration.displayName}
                        </Button>
                    </div>
                </div>
                <div className="mbsc-col-auto" >
                    <div className="mbsc-row cs-header-col-end">
                        <Button onMouseEnter={() => setIconHover('language')} onMouseLeave={() => setIconHover(null)} className="cs-header-button mbsc-bold" onClick={() => ButtonLocale()} variant="flat" >
                            <FontAwesomeIcon className="cs-header-icon" icon={faLanguage} beatFade={iconHover === 'language'} /> {locale.header.c + (width > 576 ? locale.header.d : '')}
                        </Button>
                    </div>
                </div>
            </div>
            {dialog.view === 'headerAccount' &&
                <HeaderAccount
                    locale={locale}
                    dialog={dialog}
                    Dialog={Dialog}
                    width={width}
                />
            }
            {dialog.view === 'headerRegister' &&
                <HeaderRegister
                    locale={locale}
                    dialog={dialog}
                    Dialog={Dialog}
                    registration={registration}
                    width={width}
                    Configuration={Configuration}
                    setRegistration={setRegistration}
                />
            }
            {!Empty(workspaceItem) && workspaceItem.type === 'app' &&
                <DashboardWorkspaceApp
                    locale={{}}
                    workspaceItem={workspaceItem}
                    ButtonBack={null}
                    teamtalk={{}}
                    width={width}
                    setQr={null}
                    Dialog={null}
                    setWorkspaceItem={setWorkspaceItem}
                />
            }
            {!Empty(workspaceItem) && workspaceItem.type === 'file' && workspaceItem.subtitle && workspaceItem.subtitle.toLowerCase().includes('image') &&
                <DashboardWorkspaceImage
                    locale={{}}
                    workspaceItem={workspaceItem}
                    setLoading={null}
                    teamtalk={{}}
                    navigation={null}
                    ButtonBack={null}
                    width={width}
                    setToast={null}
                    setWorkspaceItem={setWorkspaceItem}
                />
            }
        </div>
    );
}

export default Header;
